import React from "react";
import { normalizePostalCode } from "../postalAddressValidation";
// Wraps a component for a Formik <Field> so the postal code is written back in
// its normalized form, such as "00-950" for "00950" in Poland, when the field
// loses focus. Formik submits the values as typed, not the ones Yup casts, so
// the validator accepting "00950" is not enough to save "00-950".
//
// The country is read from the same place yupvalidators reads it, so the
// normalized value is always one POSTAL_CODE accepts. Wrap the component once
// at module level: wrapping it during render remounts the input on every
// render and loses focus.
const withPostalCodeNormalization = (Component) => {
    const PostalCodeField = (props) => {
        const { field, form } = props;
        const onBlur = (event) => {
            var _a;
            const normalized = normalizePostalCode((_a = field.value) !== null && _a !== void 0 ? _a : "", window.NTLF_CONFIG.portal.locale.country.twoLetterCode);
            if (normalized !== field.value) {
                form.setFieldValue(field.name, normalized);
            }
            field.onBlur(event);
        };
        return React.createElement(Component, Object.assign({}, props, { field: Object.assign(Object.assign({}, field), { onBlur }) }));
    };
    return PostalCodeField;
};
export default withPostalCodeNormalization;
